import {EditPromocode} from './edit-promocode';

export default EditPromocode;